import { Alert, Box, Snackbar } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import * as React from "react";
import CopyToClipboard from "react-copy-to-clipboard";
import QRCode from "react-qr-code";

import { doc, getDoc } from "firebase/firestore";
import { db } from "../../config/firebaseinit";
import { BootstrapButton } from "../components/styledcomponents";
import { CurrencyFormat } from "../currencyformatter";
import { RedditTextField } from "../styles";
import "../transactions/style.scoped.css";

export default function RecieveDialog({ location }) {
  const theme = useTheme();

  const [openSnackbar, setOpenSnackbar] = React.useState(false);

  // use reach router state to get
  const values = location.state;

  const [adminWallet, setadminWallet] = React.useState("");
  

  const handleClick = () => {
    setOpenSnackbar(true);
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenSnackbar(false);
  };

  React.useEffect(() => {
    console.log("coin selected", values.coin);
    
    const docRef = doc(db, "walletaddresses", values.coin);
    getDoc(docRef).then((data) => {
      console.log(data.data());

      if (data.data().address) {
        setadminWallet(data.data().address);
       // setLoading(false);
      }
    });
    
  }, []);

  const switchCoinNetwork = (key) => {
    switch (key) {
      case "BTC":
        return "BITCOIN";
      case "ETH":
        return "ERC20";
      case "TRX":
        return "TRC20";
      case "USDT ERC20":
        return "ERC20";
      case "USDT TRC20":
        return "TRC20";
      default:
        return "ETH";
    }
  };

  const address = (key) => {
    switch (key) {
      case "BITCOIN":
        return "bc1qexaqwq7u72glyu8lnnhz5feqc76ef4x6sdfapx";
      case "ETHEREUM":
        return "0xb6F567A6CDFE9ead0146fD9E3447C1ba4e6e41F7";
      case "TRON":
        return "TLYeFQyW49TTyLyUYVxE7HnKDCweHKzRtw";
      case "USDT ERC20":
        return "0xb6F567A6CDFE9ead0146fD9E3447C1ba4e6e41F7";
      case "USDT TRC20":
        return "TLYeFQyW49TTyLyUYVxE7HnKDCweHKzRtw";
      default:
        return "0xb6F567A6CDFE9ead0146fD9E3447C1ba4e6e41F7";
    }
  };

  return (
    <div>
      <div className="modal-content modal-content-demo" bis_skin_checked={1}>
        <div className="modal-header" bis_skin_checked={1}>
          <h6 className="modal-title">
            Send <CurrencyFormat amount={values.amount} />
          </h6>
        
        </div>
        <div className="modal-body" bis_skin_checked={1}>
          <p />
          <center>
            <div
              style={{
                height: "auto",
                margin: "0 auto",
                maxWidth: 200,
                width: "100%",
              }}
            >
              <QRCode
                size={256}
                style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                value={adminWallet}
                viewBox={`0 0 256 256`}
              />
            </div>
            <br />
            &nbsp;&nbsp;
            <RedditTextField
              disabled
              fullWidth
              label="Wallet Address"
              value={adminWallet}
            />
            <Box mt={1} />
            <CopyToClipboard text={adminWallet} onCopy={handleClick}>
              <BootstrapButton
                // onClick={handleClick}
                variant="contained"
                disableRipple
              >
                Copy
              </BootstrapButton>
            </CopyToClipboard>
          </center>
          <br /> <p />
          <p className="response" />
          <p />
          <ul className="list-group wd-md-100p">
            <li className="list-group-item d-flex align-items-center">
              <div bis_skin_checked={1}>
                <h6 className="tx-13 tx-inverse tx-semibold mg-b-0">Network</h6>
                <span className="d-block tx-11 text-muted">
                  {switchCoinNetwork(values.coin)}
                </span>
              </div>
            </li>
            <li className="list-group-item d-flex align-items-center">
              <div bis_skin_checked={1}>
                <h6 className="tx-13 tx-inverse tx-semibold mg-b-0">
                  Expected arrival
                </h6>
                <span className="d-block tx-11 text-muted">
                  1 network confirmation
                </span>
              </div>
            </li>
            <li className="list-group-item d-flex align-items-center">
              <div bis_skin_checked={1}>
                <h6 className="tx-13 tx-inverse tx-semibold mg-b-0">
                  Expected unlock
                </h6>
                <span className="d-block tx-11 text-muted">
                  2 network confirmations
                </span>
              </div>
            </li>
          </ul>
          <p />
        </div>
      
      </div>

      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={openSnackbar}
        autoHideDuration={10000}
        onClose={handleCloseSnackbar}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity="success"
          sx={{ width: "100%" }}
          variant="standard"
        >
          {"Address copied!"}
        </Alert>
      </Snackbar>
    </div>
  );
}
